var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.2789 2h-16.56c-.39825 0-.72.32175-.72.72v16.56c0 .3983.32175.72.72.72h16.56c.3983 0 .72-.3217.72-.72v-16.56c0-.39825-.3217-.72-.72-.72zm-2.52 4.62825-.918.87975c-.081.06075-.1192.15975-.1035.2565v6.4733c-.0157.099.0225.198.1035.2565l.9.8797v.1957h-4.518v-.1867l.9293-.9022c.0922-.0923.0922-.1193.0922-.2565v-5.23805l-2.5875 6.56095h-.3487l-3.01055-6.56095v4.39875c-.027.1845.03825.3713.16875.504l1.2105 1.4648v.1957h-3.438v-.1957l1.2105-1.4648c.06378-.0659.11124-.1458.13859-.2333s.03383-.1802.01891-.2707v-5.085c.01575-.14175-.03825-.279-.14625-.37575l-1.0755-1.296v-.19575h3.34125l2.5785 5.6588 2.2703-5.6543h3.1837z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.f891331372308cd2efd42b9687a511c5.svg";
export { ForwardRef as ReactComponent };